/* eslint-disable */
import React, { Component } from 'react'
import Card from '../../components/Card'
import OrganizersModule from '../../modules/Organizers'
import ConversionModule from '../../modules/Conversion'
import TalkModule from '../../modules/Talk'
import ActivityIntroduceModule from '../../modules/ActivityIntroduce'
import RewardModule from '../../modules/Reward'
import DynamicModule from '../../modules/Dynamic'
import ExperienceModule from '../../modules/Experience'
import LiveModule from '../../modules/Live'
import EBookModule from '../../modules/E-Book'
import InnerBannerModule from '../../modules/InnerBanner'
import { ZAShow } from 'za-react'
import styles from './ActivityInstruction.css'

export default class ActivityInstruction extends Component {
  render() {
    const {
      organization = [],
      extensionType,
      extention,
      column,
      introduce,
      experienceCard,
      live,
      ebook,
      innerBanner,
      module,
      module: {
        activityIntroduce,
        awardDeclare,
        effectChange,
        suggestedRead,
        activityDynamic,
      },
    } = this.props
    if (!organization || !organization.length) {
      return <div className={styles.activityInstructionEmpty}>加载中...</div>
    }

    return (
      <div>
        <ZAShow zaType="Page" />
        <Card>
          <OrganizersModule organizations={organization} />
          {effectChange === 1 ? (
            <ConversionModule
              className={styles.conversionModule}
              extensionType={extensionType}
              extention={extention}
            />
          ) : null}
          {suggestedRead === 1 ? <TalkModule talkData={column} /> : null}
        </Card>
        {module.experienceCard === 1 && (
          <Card>
            <ExperienceModule {...experienceCard} />
          </Card>
        )}
        {module.live === 1 && (
          <Card>
            <LiveModule liveData={live} />
          </Card>
        )}
        {module.ebook === 1 && (
          <Card>
            <EBookModule ebookData={ebook} />
          </Card>
        )}

        {(activityIntroduce === 1 || awardDeclare === 1) && (
          <Card>
            {activityIntroduce === 1 && (
              <ActivityIntroduceModule {...introduce} />
            )}
            {awardDeclare === 1 && <RewardModule {...introduce} />}
          </Card>
        )}
        {module.innerBanner === 1 && (
          <Card>
            <InnerBannerModule {...innerBanner} />
          </Card>
        )}
        {activityDynamic === 1 && (
          <Card>
            <DynamicModule
              {...this.props}
              changeDynamicId={value => this.props.changeDynamicId(value)}
            />
          </Card>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Activity/ActivityInstruction.js